import useSWR from 'swr';
import axiosInstance from '@/lib/axios';
import type { UserWithCommunities } from '@/types';

const fetcher = (url: string) => axiosInstance.get(url).then((res) => res.data);

export function useUser() {
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const { data, error, isLoading, mutate } = useSWR<{ user: UserWithCommunities }>(
    token ? '/api/user' : null,
    fetcher,
    {
      shouldRetryOnError: false,
      refreshInterval: 10000,
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    user: data?.user,
    communities: data?.user?.communities || [],
    isLoading,
    isError: error,
    mutate,
  };
}
